import React, { Suspense, useEffect, useState } from 'react'
import './assets/styles/App.scss'
import 'antd/dist/antd.min.css'
import './assets/styles/custom.scss'
import './assets/styles/error-suppression.css'
import './components/common/ThemeUtils.css'
import './theme/ThemeSwitcher.css'
import './theme/logisticsDataUi.css'
import './components/common/layout/FormFields.css'
import './components/common/badge/BaseBadge.css'
import './components/common/button/TableActionButton.css'
import './components/common/table/listTableColumns.css'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { isLoggedIn } from './utils/userUtils'
import { getLoginRedirectUrl } from './utils/authRedirect'
import generateRoutes, { fallbackRoutes } from './router'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from './redux/store'
import { processWebMenu } from './utils/menuUtils'
import { getListMenuFail, getListMenuSuccess } from '@redux/ducks/common/menu.Ducks'
import Loadding from './components/layout/Loadding'
import BasicLayout from './components/layout/BasicLayout'
import ExternalRedirect from './components/common/ExternalRedirect'
import * as userApi from '@apis/common/user.Api';

const App: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [routes, setRoutes] = useState<any[]>(fallbackRoutes)
  
  // Lấy menu data từ Redux store
  const { webChucNangAll } = useSelector((state: RootState) => state.menu)

  useEffect(() => {
    const currentRoute = routes.find((route) => route.path === location.pathname);
    if (currentRoute && currentRoute.title) {
      document.title = 'NS - ' + currentRoute.title;
    } else {
      document.title = 'NHÂN SỰ';
    }
  }, [location, routes]);

  useEffect(() => {
    fetchMyMenu()
  }, [])

  // Đăng ký đủ route app; sidebar/chức năng mặc định bypass (useMenuChucNang).
  useEffect(() => {
    try {
      setRoutes(generateRoutes(webChucNangAll || []))
    } catch (error) {
      setRoutes(fallbackRoutes)
    }
  }, [webChucNangAll])

  const fetchMyMenu = async () => {
    try {
      setIsLoading(true)
      const res: any = await userApi.getMyMenu()

      if (res.data && Array.isArray(res.data)) {
        const { webUrls, webChucNangs, webChucNangAll } = processWebMenu(res.data)
        
        dispatch(getListMenuSuccess({
          webUrls: webUrls as string[],
          webChucNangs: webChucNangs,
          webChucNangAll: webChucNangAll
        }))
      }
    } catch (error) {
      dispatch(getListMenuFail({
        webUrls: [],
        webChucNangs: [],
        webChucNangAll: []
      }))
    } finally {
      setIsLoading(false)
    }
  }

  // Hiển thị loading khi đang fetch menu data
  if (isLoading) {
    return <Loadding />
  }

  return (
    <Suspense fallback={<Loadding />}>
      <Switch>
        {routes.map(({ component: Component, path, exact, name, layout: Layout }) => (
          <Route
            key={name}
            exact={exact}
            path={path}
            render={(props: any) => {
              return (
                <Layout>
                  {isLoggedIn() ? (
                    path === '/login' ? (
                      <Redirect push to="/" />
                    ) : (
                      <Component {...props} />
                    )
                  ) : path === '/login' || path === '/privacy-policy' || path === '/developer/contact' ? (
                    <Component {...props} />
                  ) : path.includes('setting-token') ? (
                    <Component {...props} />
                  ) : (
                    <ExternalRedirect url={getLoginRedirectUrl(location.pathname)} />
                  )}
                </Layout>
              )
            }}
          />
        ))}
        {/* Alias đường dẫn cũ: /hr → /nhan-su */}
        <Route exact path="/hr/module-test" render={() => <Redirect to="/module-test" />} />
        <Route exact path="/nhan-su/trang-chu" render={() => <Redirect to="/nhan-su/ho-so-nhan-vien/list" />} />
        <Route
          path="/hr/:rest*"
          render={({ match }) => (
            <Redirect to={`/nhan-su/${match.params.rest || 'ho-so-nhan-vien/list'}`} />
          )}
        />
        <Route exact path="/hr" render={() => <Redirect to="/nhan-su/ho-so-nhan-vien/list" />} />
        {/* Alias đường dẫn cũ / gõ nhầm: /hanh-chinh → /hanhchinh */}
        <Route
          path="/hanh-chinh/:rest*"
          render={({ match }) => (
            <Redirect to={`/hanhchinh/${match.params.rest || 'trang-chu'}`} />
          )}
        />
        <Route exact path="/hanh-chinh" render={() => <Redirect to="/hanhchinh/trang-chu" />} />
        <Route exact path="/mang-xa-hoi/danh-sach" render={() => <Redirect to="/mang-xa-hoi/ban-tin" />} />
        <Route exact path="/mang-xa-hoi/trang-chu" render={() => <Redirect to="/mang-xa-hoi/ban-tin" />} />
        {/* Alias: khóa đào tạo chuyển từ /nhan-su → /dao-tao */}
        <Route
          path="/nhan-su/khoa-hoc-dao-tao/:rest*"
          render={({ match }) => (
            <Redirect to={`/dao-tao/khoa-hoc-dao-tao/${match.params.rest || 'list'}`} />
          )}
        />
        {/* Fallback route - chỉ render khi không có route nào match */}
        <Route path="*" render={() => {
          return (
            <BasicLayout>
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>404 - Trang không tồn tại</h2>
              </div>
            </BasicLayout>
          )
        }} />
      </Switch>
    </Suspense>
  )
}

export default App

